/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_2_TitleInputs */

const en_mk_problem_2_title = /** @type {(inputs: Mk_Problem_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools that don't talk to each other`)
};

const id_mk_problem_2_title = /** @type {(inputs: Mk_Problem_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools tidak nyambung`)
};

/**
* | output |
* | --- |
* | "Tools that don't talk to each other" |
*
* @param {Mk_Problem_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_2_title = /** @type {((inputs?: Mk_Problem_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_2_title(inputs)
	return en_mk_problem_2_title(inputs)
});